import Colors from '@dynatrace/strato-design-tokens/colors';

import type { MeterBarSize } from './types/meter-bars.js';
import type { MeterBarChartTooltipState } from './types/state.ts';
import type { MappedObject } from '../../core/types/helpers/mapped-object.js';

export const INITIAL_STATE = Object.freeze<MeterBarChartTooltipState>({
  position: {
    x: 0,
    y: 0,
  },
  pinned: false,
  visible: false,
});

export const METER_BAR_SIZE = Object.freeze<MappedObject<MeterBarSize>>({
  Size16: 'size16',
  Size24: 'size24',
  Size8: 'size8',
  Auto: 'auto',
});

export const MIN_DEFAULT_VALUE = 0;
export const MAX_DEFAULT_VALUE = 100;
export const LEGEND_VERTICAL_RATIO = 0.3;
export const SIZE_DEFAULT: MeterBarSize = METER_BAR_SIZE.Size16;
export const DEFAULT_FORMATTER = (v: number) => v.toString();
export const DEFAULT_GAP_WIDTH = 1;
export const DEFAULT_ICON_SIZE = 20;
export const SMALL_CHART_SIZE = 8;
export const MEDIUM_CHART_SIZE = 16;
export const LARGE_CHART_SIZE = 24;
export const DEFAULT_CHART_SIZE = MEDIUM_CHART_SIZE;
export const METER_BAR_FONT_COLOR = Colors.Text.Neutral.Default;
export const METER_BAR_MIN_MAX_FONT_COLOR = Colors.Text.Neutral.Subdued;
